(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setAnnouncementHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', () => {
        this.setHeaderHeight();
        this.setAnnouncementHeight();
      });
      window.addEventListener('resize', () => {
        this.setHeaderHeight();
        this.setAnnouncementHeight();
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      this.setHeaderEdgeOffset();
    }

    setAnnouncementHeight() {
      // Announcement bar can be absent; measure if present
      const announcement = document.querySelector('.announcement-bar-section .holdon-announcement-bar');
      const height = announcement ? announcement.offsetHeight : 0;
      document.documentElement.style.setProperty('--announcement-height', `${height}px`);
      // Toggle helper class for CSS effects when announcement is present
      if (announcement) {
        this.header.classList.add('has-announcement');
      } else {
        this.header.classList.remove('has-announcement');
      }
      this.setHeaderEdgeOffset();
    }

    setHeaderEdgeOffset() {
      // Use actual bottom edge of sticky header relative to viewport for accuracy
      const rect = this.header.getBoundingClientRect();
      const edge = Math.max(0, Math.round(rect.bottom));
      document.documentElement.style.setProperty('--header-edge-offset', `${edge}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        // Add class directly to holdon-header for better targeting
        const holdOnHeader = this.header.querySelector('.holdon-header');
        if (holdOnHeader) holdOnHeader.classList.add('scrolled');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        // Add class directly to holdon-header for better targeting
        const holdOnHeader = this.header.querySelector('.holdon-header');
        if (holdOnHeader) holdOnHeader.classList.add('scrolled');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        // Remove class from holdon-header
        const holdOnHeader = this.header.querySelector('.holdon-header');
        if (holdOnHeader) holdOnHeader.classList.remove('scrolled');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
      // Recompute announcement height based on scrolled state (0 when past header)
      this.setAnnouncementHeight();
      this.setHeaderEdgeOffset();
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
